export const goToLinkMixin = {
  data: () => ({}),
  mounted () {
  },
  computed: {},
  methods: {
    goToLink (to) {
      this.closeMainDialog();

      // http로 시작하는경우 링크를 새창으로
      if (typeof to === 'string' && to.startsWith('http')) {
        window.open(to);
        return;
      }

      switch (to) {
        case 'prepare' :
          this.showServicePrepareDialog = true;
          return;

        case 'one-day' :
          this.$router.push({ name: 'main' });
          break;

        default:
          this.$router.push(typeof to === 'object' && to || { name: to });
          break;
      }
    },
    closeMainDialog () {
      // 막아둔 스크롤 다시 동작하도록
      document.querySelector('html').classList.toggle('application--dialog-opened', false);

      // dialog 내에서는 닫히도록
      if (this.show) {
        this.$nextTick(() => {
          this.show = false;
        });
      }
    },
  },
};